"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNull = exports.isUndefined = exports.typeForDisplay = exports.isFunction = exports.isString = exports.isBoolean = exports.isNumber = exports.isDate = exports.isArray = exports.isObject = void 0;
var kind_of_1 = __importDefault(require("kind-of"));
function isObject(obj) {
    return kind_of_1.default(obj) === 'object';
}
exports.isObject = isObject;
function isArray(arr) {
    return kind_of_1.default(arr) === 'array';
}
exports.isArray = isArray;
function isDate(obj) {
    return kind_of_1.default(obj) === 'date';
}
exports.isDate = isDate;
function isNumber(obj) {
    return kind_of_1.default(obj) === 'number';
}
exports.isNumber = isNumber;
function isBoolean(obj) {
    return kind_of_1.default(obj) === 'boolean';
}
exports.isBoolean = isBoolean;
function isString(obj) {
    return kind_of_1.default(obj) === 'string';
}
exports.isString = isString;
function isFunction(obj) {
    return kind_of_1.default(obj) === 'function';
}
exports.isFunction = isFunction;
function typeForDisplay(obj) {
    return upperCaseFirst(kind_of_1.default(obj));
}
exports.typeForDisplay = typeForDisplay;
function isUndefined(obj) {
    return kind_of_1.default(obj) === 'undefined';
}
exports.isUndefined = isUndefined;
function isNull(obj) {
    return kind_of_1.default(obj) === 'null';
}
exports.isNull = isNull;
function upperCaseFirst(str) {
    if (!isString(str)) {
        return str;
    }
    var first = str.slice(0, 1).toUpperCase();
    var rest = str.slice(1, str.length);
    return first + rest;
}
//# sourceMappingURL=type-utils.js.map